import {Message } from 'element-ui'
export default class ValidateInterceptor {
    static intercept(response){
        if(response.data.code == 1001){
            let msg = response.data.msg;
            let errorMsg = "";
            for(let i=0;i<msg.length;i++){
                errorMsg += "<p><strong>"+msg[i].message+"</strong></p>";
            }
            Message.error({
                dangerouslyUseHTMLString: true,
                message:errorMsg
            });
        }
    }
}
